import React from 'react';
import "./Footer.css";
function Footer() {
    return (
        <div className="footercont">
            <div className="footer">
                Built and Designed by Christopher Tran
            </div>
        </div>
    )
}

export default Footer
